// extracted by css-extract-rspack-plugin
export default {"confirmActions":"confirmActions-kzxSXN","editRow":"editRow-m1G2t5","list":"list-VWzOYF"};